import React, { Component } from 'react'
import { connect } from 'react-redux'
import { actions } from '../store/actions/new-document.actions'
import { actions as contractorActions } from '../../../actions/contractor.actions'
import {
  DatePicker,
  Col,
  Row,
  Form,
  Modal,
  Select,
  Input,
  Upload,
  Icon,
  Button,
  Divider,
  message,
} from 'antd';
import { dspxGetDocTypesChildrens, dspxGetChildrens, dspxGetChildrensDocumentContractor, dspxGetWorkerChildrens } from '../../../helpers/dspx-utils'
import { ReactComponent as AddDocumentIcon } from '../../../resource/forms/DocPlus.svg';
import moment from 'moment'
import ContractorRef from '../../../components/contractor-ref';
import RepeatingFields from './repeating-filelds'
import NewDocumentsAddressField from './new-documents-address-field'
import { DraftIcon } from '../../../resource/icons'
import ContactorRadioButton from '../ContractorRadioButton/ContractorRadioButton'
import { docTypes } from '../constants/documents.constants';
import { checkDocTypeHasSubtype } from '../table/utils/checkDocTypeHasSubtype';
import AllModal from '../editDocument/AllModal/AllModal';

let id = 1
let addonId = 0

const FormDivider = () => (
  <Divider
    style={{
      height: '2px',
      margin: '8px 0',
    }}
  />
);

const NewDocumentForm = Form.create()(
	class extends React.Component {
		constructor(props) {
			super(props)

			this.state = {
				fileList: [],
				addonFileList: [],
				descriptionValue: '',
				stateAllModal: false,
			}
		}

		add = () => {
			const { form } = this.props;
			const keys = form.getFieldValue('keys');
			const nextKeys = keys.concat(id++);
			form.setFieldsValue({
				keys: nextKeys,
			});
		};

		addAddon = () => {
			const { form } = this.props;
			const keys = form.getFieldValue('addonKeys');
			const nextKeys = keys.concat(addonId++);
			form.setFieldsValue({
				addonKeys: nextKeys,
			});
		};

		remove = k => {
			const { form } = this.props;
			const keys = form.getFieldValue('keys');
			if (keys.length === 1) {
				return;
			}	
			form.setFieldsValue({
				keys: keys.filter(key => key !== k),
			});
		};

		removeAddon = k => {
			const { form } = this.props;
			const keys = form.getFieldValue('addonKeys');
			if (keys.length === 0) {
				return;
			}	
			form.setFieldsValue({
				addonKeys: keys.filter(key => key !== k),
			});
		};

		handleAddrStreetChange = (value) => {
			this.props.form.resetFields(['addressId'])
			this.props.dispatch(actions.applyAddrStreet(value));
		}

		handleAddrBuildingChange = (value) => {
			this.props.form.resetFields(['addressId'])
			this.props.dispatch(actions.applyAddrBuilding(value))
		}

		changeDescription = (e)=>{
			const newValue = e.target.value;
        this.setState({
          descriptionValue: newValue,
        });
		}

		openModal = () => {
			this.setState(prevState => ({
				...prevState, 
				stateAllModal: true,
			}))
		}
	
		closeModal = () => {
			this.setState(prevState => ({
				...prevState, 
				stateAllModal: false,
			}))
		}

		render() {
			const { visible, onCancel, onCreate, form, fprops } = this.props;
			const {listAddrStreet,listAddrBuilding,listAddrFlat,valueAddrStreet,valueAddrBuilding,valueAddrFlat} 
				= this.props.fprops
			const { getFieldDecorator, getFieldValue } = form;	

			const docType = getFieldValue('typeId')
			const contractorType = getFieldValue('contractorType')
			const subTypeId =  getFieldValue('subTypeId') ?? 4;
			const executerIds = form.getFieldValue('executerIds');
			
			const subject = "Исполнители";
			const subject_err = "исполнителей";

			getFieldDecorator('keys', { initialValue: [0] });
			const keys = getFieldValue('keys');
			const orgsItems = keys.map(
				(k, index) =>
					(docType === docTypes.outgoing || docType === docTypes.incoming || 
						(docType === docTypes.contract && subTypeId !== 7) || 
						index === 0) && (
						<Row gutter={0} key={k}>
							<Form.Item
								label={
									index === 0 ? (
											<div className="ant-form-item-required">Адресат</div>
									) : (
										""
									)
								}
								required={false}
								key={k}
							>
								<Col span={23}>
									{getFieldDecorator(`orgId[${k}]`, {
										rules: [
											{
												// required: [docTypes.out, docTypes.in].includes(docType) && contractorType == "org_data",
												message:
													"Пожалуйста, укажите организацию отправителя/получателя документа",
											},
										],
									})(
										<Select
											showSearch
											placeholder="организация"
											notFoundContent="нет данных"
											optionFilterProp="searchtext"
										>
											{dspxGetChildrensDocumentContractor(
												fprops.documentContractors,
												true,
												true
											)}
										</Select>
									)}
								</Col>
								<Col span={1} style={{ textAlign: "right" }}>
									{keys.length > 1 && docType === docTypes.outgoing ? (
										<Icon
											style={{ fontSize: 20, color: "#ffb6b6", marginTop: 5 }}
											type="minus-circle"
											onClick={() => this.remove(k)}
										/>
									) : null}
								</Col>
							</Form.Item>
						</Row>
					)
			);

			getFieldDecorator('addonKeys', { initialValue: [] });
			const addonKeys = getFieldValue('addonKeys');
			const addonItems = addonKeys.map((k, index) => (
				<Row gutter={0}>
				<Form.Item					
					label={index === 0 ? 'Дополнительные документы' : ''}
					required={false}
					key={k}>

					<Row gutter={8}>
							<Col span={8}>
							<Form.Item >
										{ getFieldDecorator(`addonTypeId[${k}]`, { initialValue: '1', 
											rules: [{ required: true, message: 'Пожалуйста, укажите тип дополнения' }]
									})(
										<Select
											style={{ width: 190 }}
											showSearch
											placeholder="тип дополнения"
											notFoundContent='нет данных'
											optionFilterProp="searchtext" >
											{dspxGetChildrens(fprops.listOrdType)}
										</Select>)}
								</Form.Item>
							</Col>
							<Col span={14}>
							<Form.Item  >
									{getFieldDecorator(`addonfile[${k}]`, {
										initialValue: null,
										rules: [{ required: true, message: 'Пожалуйста прикрепите файл документа' }]
									})(										
										<Upload.Dragger
										fileList={this.state.addonFileList[k]}
										multiple={false}
										beforeUpload={(file) => {
											const afl = this.state.addonFileList.slice()
											afl[k] = [file]
											this.setState({
												addonFileList: afl
											});
											return false;
										}}
										onRemove={(file) => {
											const afl = this.state.addonFileList.slice()
											afl[k] = []
											this.setState({
												addonFileList: afl,
											})
										}}>
										<Icon type="file-add" theme="outlined" /> выбрать файл дополнения 
								</Upload.Dragger>
										
										)}
								</Form.Item>
							</Col>
							<Col span={2}>
					{addonKeys.length > 0 ? (
						<Icon
							style={{fontSize: 22, color: "#ffb6b6", marginTop: 5}} 
							type="minus-circle"
							onClick={() => this.removeAddon(k)}
						/>
					) : null}
								</Col>

							</Row>
							<Row gutter={8}>
							<Col span={14}>
								<Form.Item >
									{getFieldDecorator( `addonTopic[${k}]`, {
										rules: [
											{
												required: true,
												message: 'Пожалуйста, укажите тему'
											},
											{
												max: 200,
												message: 'Длина темы не должна превышать 200 символов'
											},
										]
									})( <Input placeholder="тема"/>)}
								</Form.Item>																			
							</Col> 
							<Col span={5}>
								<Form.Item >
									{getFieldDecorator( `addonNumber[${k}]`, {
										rules: [{ required: true, message: 'Пожалуйста, укажите номер документа' }]
									})( <Input placeholder="номер" />)}
								</Form.Item>																			
							</Col> 
							<Col span={5}>
							<Form.Item >
									{getFieldDecorator( `addonMoment[${k}]`, {
										rules: [{ required: true, message: 'Пожалуйста, укажите дату документа' }]
									})(
										<DatePicker placeholder="дата" style={{width:115}} allowClear={false} format='DD.MM.YYYY' />)}
								</Form.Item>
							</Col> 
						</Row>
				</Form.Item>
				</Row>
			));

			return (
				<Modal
					style={{minWidth:650}}
					width={650}
					visible={visible}
					title={<span><AddDocumentIcon style={{ height: 40, verticalAlign:'middle', marginRight: 10 }}/> Добавить документ</span>}
					footer={
						<div style={{display: "flex", justifyContent: "flex-end"}}>
							<Button style={{ marginRight: 20, padding: "8px 16px", height: "auto" }}
								onClick={onCancel}
							>
								Отменить
							</Button>
							<Button style={{
								background: "#305CCC",
								color: "#ffffff",
								display: "flex",
								alignItems: "center",
								height: "auto",
								padding: "8px 16px",
							}}
								onClick={onCreate}
							>
								<DraftIcon style={{marginRight: 8}}/>
								Добавить</Button>
						</div>
					}
					onCancel={onCancel}
					 >
					<Form layout="vertical">
					<Row gutter={8}>
              <Col span={checkDocTypeHasSubtype(docType) ? 24 : 10}>
								<Form.Item label="Тип">
								<Input.Group compact>
									{getFieldDecorator('typeId', {
										initialValue: docTypes.outgoing,
											rules: [{ required: true, message: 'Пожалуйста, укажите тип документа' }]
									})(
										<Select
											style={{ width: 220 }}
											showSearch
											placeholder="тип документа"
											notFoundContent='нет данных'
											optionFilterProp="searchtext" >
											{dspxGetDocTypesChildrens(fprops.listDocumentType, "withoutImg")}
										</Select>)}
                    {docType === docTypes.organizational &&
                      getFieldDecorator('ordTypeId', {
                        initialValue: 1,
                        rules: [
                          {
                            required: true,
                            message: 'Пожалуйста, укажите тип ОРД',
                          },
                        ],
                      })(
										<Select
											style={{ width: 180 }}
											showSearch
											placeholder="тип ОРД"
											notFoundContent='нет данных'
											optionFilterProp="searchtext" >
                          {dspxGetChildrens(
                            fprops.listOrdType,
                            23,
														false,
                            (el) => el.id
                          )}
										</Select>)}
                    {docType === docTypes.meeting &&
                      getFieldDecorator('subTypeId', {
                        initialValue: 1,
                        rules: [
                          {
                            required: true,
                            message: 'Пожалуйста, укажите тип ОСС',
                          },
                        ],
                      })(
                        <Select
                          style={{ width: 180 }}
                          showSearch
                          placeholder="тип ОСС"
                          notFoundContent="нет данных"
                          optionFilterProp="searchtext"
                        >
                          {dspxGetChildrens(
                            fprops.listOssType,
                            23,
														false,
                            (el) => el.id
                          )}
                        </Select>
                      )}
                    {docType === docTypes.contract &&
                      getFieldDecorator('subTypeId', {
                        initialValue: 4,
                        rules: [
                          {
                            required: true,
                            message: 'Пожалуйста, укажите тип договора',
                          },
                        ],
                      })(
                        <Select
                          style={{ width: 180 }}
                          showSearch
                          placeholder="тип договора"
                          notFoundContent="нет данных"
                          optionFilterProp="searchtext"
                        >
                          {dspxGetChildrens(
                            fprops.listContractType,
                            23,
														false,
                            (el) => el.id
                          )}
                        </Select>
                      )}
									</Input.Group>
                  {docType === docTypes.organizational && (
                    <p>
                      Будет установлен порядковый номер совместно с датой
                      создания.
                    </p>
                  )}
								</Form.Item>
							</Col>
							{ docType !== docTypes.organizational && <Col span={7}>
							<Form.Item label="Номер">
									{ getFieldDecorator( 'DocNumber', {
										rules: [{ required: true, message: 'Пожалуйста, укажите номер документа' }]
									})( <Input style={{width: "160px"}} />)}
								</Form.Item>
								</Col> }
								{ docType !== docTypes.organizational && <Col span={7}>
							<Form.Item label="Дата регистрации">
									{getFieldDecorator( 'DocMoment', {
										initialValue: moment(),
										rules: [{ required: true, message: 'Пожалуйста, укажите дату документа' }]
									})(
										<DatePicker  allowClear={false} format='DD.MM.YYYY'/>)}
								</Form.Item> 
									</Col> }
						</Row>

						<Row gutter={8}>
							<Col span={17}>
								<Form.Item label={docType === docTypes.contract ? "Предмет договора" 
										: (docType === docTypes.incoming ? "Описание" : "Тема")}>
									{getFieldDecorator('Topic', {
										rules: [{ required: true, message: 'Пожалуйста, укажите тему документа' }]
									})(
										<Input />)}
								</Form.Item>
							</Col>
							<Col span={7}>
								<Form.Item label="Дата назначения">
									{getFieldDecorator( 'DocDoneDate', {
											rules: [{ required: true, message: 'Пожалуйста, укажите дату назначения' }]
										})(
											<DatePicker  allowClear={false} format='DD.MM.YYYY'/>)}
								</Form.Item>
							</Col>
						</Row>
						
						<Row gutter={16}>
							<Col span={24}>
								<Form.Item label="Файлы документа">
									{getFieldDecorator('docfile', {
										initialValue: null,										
										rules: [{ 
											required: true, 
											validator: (rule, value, callback) => {
												if(!(value && value.fileList && value.fileList.length > 0) ) callback(true) 
												else callback()
											},
											message: 'Пожалуйста прикрепите файлы документа' }]
									})(
										<Upload.Dragger
											fileList={this.state.fileList}
											multiple={true}
											beforeUpload={(file) => {
												this.setState(({ fileList }) => ({
													fileList: [...fileList, file]
												}));
												return false;
											}}
											onRemove={(file) => {
												this.setState(({ fileList }) => {
													const index = fileList.indexOf(file);
													const newFileList = fileList.slice();
													newFileList.splice(index, 1);
													return {
														fileList: newFileList,
													};
												});
											}}>
											<div style={{padding: "15px"}}>
												<Icon type="file-add" theme="outlined" /> перетащите файлы документа сюда, или нажмите, чтобы выбрать
											</div>
									</Upload.Dragger>)}
								</Form.Item>
							</Col>
						</Row>
						<Row>
							<Form.Item
								label="Комментарий"
							>
								{getFieldDecorator('Description', {
									rules: [
										{
											max: 1024,
											message: 'Комментарий не должен превышать 1024 символа.',
										},
									],
								})(
									<Input.TextArea onChange={this.changeDescription} />
								)}
								<div style={{textAlign: 'right'}}>{`${this.state.descriptionValue.length}/1024`}</div>
							</Form.Item>
						</Row>

						{[docTypes.outgoing, docTypes.incoming].includes(docType) && <>
						<FormDivider />
						<Row gutter={16} style={{marginTop: 15}}>
						<Col span={4} style={{ paddingTop: 5 }}>
							Контрагент
						</Col>
						<Col span={20} style={{textAlign:"start"}}>
							<Form.Item>
								{getFieldDecorator("contractorType", {
											initialValue: "fio_data",
										})(<ContactorRadioButton />)}
							</Form.Item>
						</Col>
					</Row></>}

					{(((docType === docTypes.outgoing || docType === docTypes.incoming) &&
  contractorType === 'org_data' ) || 
  (docType === docTypes.contract && subTypeId !== 7)) &&
  orgsItems}

{(((docType === docTypes.outgoing || docType === docTypes.incoming) &&
  contractorType === 'org_data' ) || 
  (docType === docTypes.contract && subTypeId !== 7))  && (
    <Row gutter={0} align="middle">
      <Col span={9} align={"left"}>
        {(docType === docTypes.outgoing || 
         (docType === docTypes.contract && subTypeId !== 7)) && (
          <Form.Item>
            <Button
              type="link"
              style={{ color: "#888888", padding: "0px" }}
              onClick={this.add}
            >
              <Icon type="plus-circle" style={{ color: "#09A2F2" }} />
              Добавить адресата
            </Button>
          </Form.Item>
        )}
      </Col>
      <Col span={5} align={"right"}></Col>
      <Col span={9} align={"right"}>
        <Form.Item>
          <ContractorRef 
            reftype='document' 
            searchInnUrl={"/Docs/orgs_by_inn"}
            addCreatedOrg={(createdOrgId) => {
              const keys = form.getFieldValue("keys");
              for (const key of keys) {
                if (!form.getFieldValue(`orgId[${key}]`)) {
                  form.setFieldsValue({ [`orgId[${key}]`]: `${createdOrgId}` });
                  break;
                }
              }
            }} 
          />
        </Form.Item>
      </Col>
      <Col span={1} align={"right"}></Col>
    </Row>
)}

						{getFieldDecorator("custNameKeys", { initialValue: [0] })}
            {(
							([docTypes.outgoing, docTypes.incoming].includes(docType) && contractorType !== 'org_data') ||
  						(docType === docTypes.contract && subTypeId === 7 && contractorType !== 'org_data')
						) &&(
						<RepeatingFields
							form={form}
							formKey={"custNameKeys"}
							label="Адресат"
							renderOneItem={(index, allowDelete, deleteItem) => {
								return (
									<div style={{ marginBottom: 10, display: "flex" }} key={`custNames${index}`}>
										<div style={{ flexGrow: 1 }}>
											{getFieldDecorator(`custNames[${index}]`, {
												rules: [
													{
														// required: contractorType !== "org_data",
														message: 'Пожалуйста введите ФИО собственника'
													},
													{
														message: "Пожалуйста, укажите ФИО без запятых. Чтобы добавить еще одного адресата, нажмите кнопку выше.",
														validator: (_rule, value, callback) => !value || !value.includes(",")
													},
													{
														max: 150,
														message:
															"Длина поля ФИО не должна превышать 150 символов.",
													},
												]
											})(
													<Input placeholder="ФИО" name="name" />
											)}
										</div>
										{allowDelete && <Icon
											style={{ fontSize: 20, color: "#ffb6b6", marginTop: 5, marginLeft: 10 }}
											type="minus-circle"
											onClick={() => deleteItem(index)} />}
									</div>
								)
							}}
							addButtonText="Добавить собственника"
						/>)}

						{getFieldDecorator("addressKeys", { initialValue: [0] })}
            {[docTypes.outgoing, docTypes.incoming, docTypes.contract, docTypes.meeting].includes(docType) &&
              contractorType !== 'org_data' && (
							<RepeatingFields
								form={form}
								formKey={"addressKeys"}
								label="Адрес МКД"
								renderOneItem={(index, allowDelete, deleteItem) => {
									return (
										<Row type="flex" key={`address_${index}`}>
											{form.getFieldDecorator(`addressIds[${index}]`, {
												rules: [
													{
														// required: contractorType !== "org_data",
														message: "Пожалуйста, выберите адрес.",
													},
												],
											})(
												<NewDocumentsAddressField
													allowDelete={allowDelete}
													listAddrStreet={listAddrStreet}
													form={form}
													indexKey={index}
													contractorType={contractorType}
												/>
											)}
											{allowDelete && (
												<Icon
													style={{
														fontSize: 20,
														color: "#ffb6b6",
														marginTop: 5,
														marginLeft: 10,
													}}
													type="minus-circle"
													onClick={() => deleteItem(index)}
												/>
											)}
										</Row>
									);
								}}
								addButtonText="Добавить адрес"
							/>
						)}
						<FormDivider />
						<Row gutter={8}>
							<Col span={12}>
							{(docType !== docTypes.meeting && docType !== docTypes.contract) && (
								<Form.Item label="Компания">
									{getFieldDecorator('serviceCompanyId', {																					
											initialValue: fprops.listServiceCompanies?.length === 1
												? fprops.listServiceCompanies[0].id
												: undefined,
											rules: [
												{
													required: true,
													message: 'Пожалуйста, укажите управляющую компанию',
												},
											],
										})(
											<Select
												showSearch
												placeholder="Управляющая компания"
												notFoundContent='нет данных'
												optionLabelProp="label"
												optionFilterProp="searchtext"
												onChange={(companyId) => {
													// const company = (fprops.listServiceCompanies || []).find(
													// 	(c) => c.id === Number(companyId)
													// );

													form.setFieldsValue({
														executerKeys: [0],
														executerIds: [],
														ResponsibleWorkerId: undefined,
													});
												}}
											>
												{dspxGetChildrens(fprops.listServiceCompanies)}
											</Select>
									)}
								</Form.Item>
							)}	
							</Col>
						</Row>
						{getFieldDecorator("executerKeys", { initialValue: [0] })}
						<Row gutter={8}>
						<Col span={12}>
								<Form.Item label={subject}>
															{getFieldDecorator("executerIds", {
																rules: [
																	{
																		required: true,
																		message: "Пожалуйста, укажите " + subject_err,
																	},
																],
															})(
																<Select
																	showSearch
																	placeholder='исполнители'
																	notFoundContent="нет данных"
																	optionLabelProp="label"
																	optionFilterProp="searchtext"
																	mode="multiple"
																	maxTagCount={3}
																	maxTagPlaceholder={(omittedValues) => (
																		<span 
																			onClick={(e) => {
																				e.stopPropagation();
																				e.preventDefault();
																				this.openModal();
																			}}
																			style={{
																				cursor: 'pointer',
																				color: '#1890ff',
																				marginLeft: 4,
																				pointerEvents: 'auto'
																			}}
																		>
																			{`Показать все ${omittedValues.length + 3}`}
																		</span>
																	)}
																	onSelect={(value, option) => {
																		if (value === 'SELECT_ALL') {
																			const allValues = fprops.listExecuter.map(worker => worker.id);
																			const indexArray = allValues.map((_, i) => i);
																			form.setFieldsValue({
																				executerIds: allValues,
																				executerKeys: indexArray,
																			});
																		} else if (value === 'CLEAR_ALL') {
																			form.setFieldsValue({
																				executerIds: [],
																				executerKeys: [0]
																			});
																		}
																	}}
																	onChange={(selectedValues) => {
																		const indexArray = selectedValues.map((_, i) => i);
																		form.setFieldsValue({
																			executerKeys: indexArray,
																		});
																	}}
																>
																	<Select.Option value="SELECT_ALL" label="Выбрать всех" searchtext="выбрать всех">
																		<b>Выбрать всех</b>
																	</Select.Option>
																	<Select.Option value="CLEAR_ALL" label="Снять всех" searchtext="снять всех">
																		<b>Снять всех</b>
																	</Select.Option>
								
																	{dspxGetWorkerChildrens(fprops.listExecuter, undefined, true)}
																</Select>
															)}
														</Form.Item>
														{/* <RepeatingFields
									form={form}
									renderOneItem={(index, allowDelete, deleteItem) => {
										return (
											<div key={`executerIds${index}`} style={{marginBottom: 10}}>
												{getFieldDecorator(`executerIds[${index}]`, {																					
													rules: [{
														required: true, message: 'Пожалуйста, укажите исполнителя'
													}]
													})(
														<Select
															style={allowDelete ? { maxWidth: "89%"} : {}}
															showSearch
															placeholder="Исполнитель"
															notFoundContent='нет данных'
															optionLabelProp="label"
															optionFilterProp="searchtext"
															onChange={(executerId) => {
																const executer = fprops.listExecuter.find(
																	(e) => e.id === Number(executerId)
																);

																if (executer && (
																	!getFieldValue('serviceCompanyId') ||
																	Number(getFieldValue('serviceCompanyId')) !== executer.serviceCompanyId
																)) {
																	form.setFieldsValue({
																		serviceCompanyId: String(executer.serviceCompanyId),
																	})
																}
															}}
														>
															{dspxGetWorkerChildrens(fprops.listExecuter.filter((e) =>
																getFieldValue('serviceCompanyId') ?
																	e.serviceCompanyId === Number(getFieldValue('serviceCompanyId'))
																	: true
															))}
														</Select>
												)}
												{allowDelete && <Icon
														style={{
															fontSize: 20, color: "#ffb6b6",
															marginTop: 5, marginLeft: 10
														}}
														type="minus-circle"
														onClick={() => deleteItem(index)}
													/>}
										</div>)
									}}
									formKey="executerKeys"
									addButtonText="Добавить исполнителя"
									label="Исполнитель"
								/> */}
						</Col>
							<Col span={12}>
								<Form.Item label="Ответственный">
									{getFieldDecorator('ResponsibleWorkerId', {																					
										rules: [{ required: true, message: 'Пожалуйста, укажите ответсвенного' }]
									})(
										<Select
											showSearch
											placeholder="Отвественный"
											notFoundContent='нет данных'
											optionLabelProp="label"
											optionFilterProp="searchtext"
											onChange={(responsibleWorkerId) => {
												const responsibleWorker = fprops.responsibleWorkers.find(
													(rw) => rw.id === Number(responsibleWorkerId)
												);

												if (responsibleWorker && (
													!getFieldValue('serviceCompanyId') ||
													Number(getFieldValue('serviceCompanyId')) !== responsibleWorker.companyId
												)) {
													form.setFieldsValue({
														serviceCompanyId: String(responsibleWorker.companyId),
													})
												}
											}}
										>
											{dspxGetWorkerChildrens(fprops.responsibleWorkers.filter((rw) =>
												getFieldValue('serviceCompanyId')
													? rw.companyId === Number(getFieldValue('serviceCompanyId'))
													: true
											))}
										</Select>)}
								</Form.Item>
							</Col>
							</Row>

						{docType == -1 && addonItems}
						{docType == -1 && <Row gutter={0} align='middle'>
						<Col span={24} align={'right'}>
							<Form.Item>
          			<Button type="dashed" onClick={this.addAddon} >
            			<Icon type="plus" /> Дополнение </Button>
        			</Form.Item>
							</Col>
							<Col span={2} > </Col>
						</Row>}

						<FormDivider />

						<Row>
							<Form.Item label="Видимость документа">
								{getFieldDecorator('documentVisibility', {																					
									initialValue: undefined,
									rules: [
										{
											required: true,
											message: 'Пожалуйста, укажите видимость документа',
										},
									],
								})(
									<Select
										placeholder="Видимость документа"
										notFoundContent="нет данных"
									>
										{fprops.listDocumentVisibility.map((visibilityOption) => (
											<Select.Option
												key={visibilityOption.id}
												value={visibilityOption.id}
											>
												{visibilityOption.name}
											</Select.Option>
										))}
									</Select>
								)}
							</Form.Item>
						</Row>

					</Form>
					<AllModal visible={this.state.stateAllModal} currentValues={executerIds} workersList={fprops.listExecuter} closeModal={this.closeModal} />
				</Modal>
			);
		}
	});

class NewDocumentContainer extends Component {

	componentDidMount() {
		this.props.dispatch(actions.fetchDocumentTypeList());
		this.props.dispatch(actions.fetchOrdTypeList());
		this.props.dispatch(actions.fetchOssTypeList());
		this.props.dispatch(actions.fetchContractTypeList());
		this.props.dispatch(actions.fetchExecuterList());
		this.props.dispatch(actions.fetchResponsibleWorkersList());
		this.props.dispatch(contractorActions.fetchDocumentContractorList());
		this.props.dispatch(actions.fetchAddrStreetList());
		this.props.dispatch(actions.fetchServiceCompaniesList());
		this.props.dispatch(actions.fetchDocumentVisibilityList());
	}

	handleCancel = () => {
		const form = this.formRef.props.form
		this.formRef.state.fileList = []
		form.resetFields()
		this.props.dispatch(actions.closeNewDocumentModal())
		this.props.dispatch(actions.applyAddrStreet(undefined))
	}

	handleCreate = () => {
		const form = this.formRef.props.form;
		form.validateFieldsAndScroll((err, values) => {

			if (err) {
				message.error('Заполните обязательные поля');
				return;
			}

			const v = { ...values, 
				files: this.formRef.state.fileList, 
				addonFiles: this.formRef.state.addonFileList,
			}

			form.resetFields();
			this.formRef.state.fileList = [];

			this.props.dispatch(actions.postDocument(v))
			this.props.dispatch(actions.closeNewDocumentModal())
			this.props.dispatch(actions.applyAddrStreet(undefined));
		});
	}

	saveFormRef = (formRef) => {
		this.formRef = formRef;
	}

	render() {
		return (
			<NewDocumentForm
				wrappedComponentRef={this.saveFormRef}
				visible={this.props.newDocumentModalVisible}
				dispatch={this.props.dispatch}
				onCancel={this.handleCancel}
				onCreate={this.handleCreate}
				fprops={this.props}
			/>
		)
	}
}

function mapStateToProps(state) {
	const { newDocumentStore } = state;
	const { documentContractors } = state.contractorStore;
	return {...newDocumentStore, documentContractors };
}

export default connect(mapStateToProps)(NewDocumentContainer);